import { connect } from 'react-redux'
import Menu from './Menu.js'
import { changePage, clearStompunkt } from '../../actionCreators'

const mapStateToProps = (state, ownProps) => ({
	currentPage: state.currentPage[0]
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	onChange: (event, value) => {
		dispatch(changePage(value));
		dispatch(clearStompunkt());
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(Menu)


// WEBPACK FOOTER //
// ./src/components/Header/MenuContainer.js